function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStopwatch = function SvgStopwatch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M8 1a1 1 0 0 0 0 2h1v1.071a7 7 0 1 0 6.606 2.737l.758-.758a.999.999 0 1 0-1.414-1.414l-.758.758A6.958 6.958 0 0 0 11 4.071V3h1a1 1 0 0 0 0-2H8zm2 5.5a1 1 0 0 1 1 1v3.586l1.707 1.707a.999.999 0 1 1-1.414 1.414l-2-2A.997.997 0 0 1 9 11.47V7.5a1 1 0 0 1 1-1z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    }
  }));
};
export default SvgStopwatch;